<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>
      <v-card>
        <v-card-title>
          <span class="headline">Routing</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>
                <table
                  class="table table table-striped table-bordered mobile-table"
                >
                  <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Service Number</th>
                      <th scope="col">Routing</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rows" :key="index">
                      <td align="center">
                        <div v-show="row.inboundID">
                          <v-icon color="green">check_circle</v-icon>
                        </div>
                      </td>
                      <td
                        :class="{
                          '': true,
                          danger: errors.has('serviceNumber' + index),
                        }"
                      >
                        <input
                          class="form-control"
                          v-validate="
                            row.typeOfNumber == 'new'
                              ? ''
                              : 'required|phonenumber'
                          "
                          :name="'serviceNumber' + index"
                          v-model="row.serviceNumber"
                        />
                      </td>
                      <td
                        :class="{
                          '': true,
                          danger: errors.has('routing' + index),
                        }"
                      >
                        <select
                          :name="'routing' + index"
                          class="form-control"
                          v-model="row.routing"
                          v-validate="'required'"
                          title="You cannot change routing until you have saved this table."
                          @change="changeRouting({ e: $event, row: row })"
                          :disabled="row.inboundID == 0"
                        >
                          <option value="australia">Australia Wide</option>
                          <option value="state">State</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialog = false"
            >Close</v-btn
          >
          <v-btn color="blue darken-1" flat @click.native="dialog = false"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
export default {
  data: () => ({
    dialog: false,
  }),
};
</script>
